import React from 'react';
import ProdList from 'src/components/eventProd/ProdList';

const EventProd = () => {
  return <ProdList />;
};

export default EventProd;
